(function(){
'use strict';

/*
  BGC desktop homepage quick-add — native trigger removal.
  Retina's .ajax-submit handler is detached from the homepage coffee buttons
  on desktop. BGC owns only those clicks, adds through Shopify's Ajax Cart API,
  silently syncs the existing drawer, and never opens or closes mmenu.
*/
if(window.__BGC_QUICK_ADD_RELIABILITY_2026__)return;
window.__BGC_QUICK_ADD_RELIABILITY_2026__=1;

/* Retire the older close-after-open Stage 1 block before commerce registers. */
window.__BGC_PLAN_B_STAGE1_V2_2026__=1;

var DESKTOP='(min-width:768px)';
var RESTORE_SUCCESS_MS=520;
var RESTORE_ERROR_MS=900;

function desktopHome(){
  return !!(window.matchMedia&&window.matchMedia(DESKTOP).matches&&document.body&&document.body.classList.contains('index'));
}
function closest(target,selector){
  return target&&target.closest?target.closest(selector):null;
}
function route(path){
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  if(root.slice(-1)!=='/')root+='/';
  return root+String(path||'').replace(/^\//,'');
}
function detachNativeButtons(){
  if(!desktopHome())return;
  Array.prototype.slice.call(document.querySelectorAll('.bgc-coffee-showcase .bgc-quick-add .ajax-submit')).forEach(function(button){
    if(!button||!button.parentNode)return;
    var clone=button.cloneNode(true);
    clone.classList.remove('ajax-submit');
    clone.classList.add('bgc-native-bypass-add');
    clone.setAttribute('data-bgc-native-detached','1');
    button.parentNode.replaceChild(clone,button);
  });
}
function labelNode(button){
  return button&&button.querySelector?button.querySelector('.text'):null;
}
function originalLabel(button){
  if(!button)return '';
  if(!button.getAttribute('data-bgc-original-label')){
    var node=labelNode(button);
    button.setAttribute('data-bgc-original-label',node?String(node.textContent||''):String(button.textContent||''));
  }
  return button.getAttribute('data-bgc-original-label')||'';
}
function setLabel(button,text){
  var node=labelNode(button);
  if(node)node.textContent=text;
  else button.textContent=text;
}
function setBusy(button){
  originalLabel(button);
  button.setAttribute('data-bgc-quick-add-busy','1');
  button.setAttribute('aria-busy','true');
  button.disabled=true;
  setLabel(button,'ADDING…');
}
function restoreButton(button,delay,text){
  setLabel(button,text);
  setTimeout(function(){
    if(!button)return;
    setLabel(button,originalLabel(button));
    button.disabled=false;
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-bgc-quick-add-busy');
  },delay);
}
function quantityFrom(form){
  var input=form&&form.querySelector('[name="quantity"]');
  var qty=parseInt(input&&input.value,10);
  return isFinite(qty)&&qty>0?qty:1;
}
function getCart(){
  return fetch(route('cart.js'),{
    credentials:'same-origin',
    cache:'no-store',
    headers:{'Accept':'application/json'}
  }).then(function(response){
    if(!response.ok)throw new Error('Cart read failed');
    return response.json();
  });
}
function updateHeaderCount(cart){
  var count=parseInt(cart&&cart.item_count,10);
  if(!isFinite(count)||count<0)count=0;

  Array.prototype.slice.call(document.querySelectorAll('#trewq .nav.mobile_hidden .cart-button:not(.no-js-only)')).forEach(function(button){
    var node=button.querySelector('.cart_count');
    if(count>0){
      if(!node){
        node=document.createElement('div');
        node.className='cart_count';
        var label=button.querySelector('span');
        button.insertBefore(node,label||button.firstChild);
      }
      node.textContent=String(count);
    }else if(node&&node.parentNode){
      node.parentNode.removeChild(node);
    }
  });

  Array.prototype.slice.call(document.querySelectorAll('#header .mobile-icons .cart-button span')).forEach(function(node){
    node.textContent=String(count);
  });
}
function headerSectionUrl(){
  var url=new URL(window.location.href);
  url.hash='';
  url.searchParams.set('section_id','header');
  url.searchParams.set('_bgc_cart_refresh',String(Date.now()));
  return url.toString();
}
function readMarkupCount(ul){
  var total=0;
  Array.prototype.slice.call(ul.querySelectorAll('input.quantity.updates, input.updates[type="number"]')).forEach(function(input){
    var qty=parseInt(input.value,10);
    if(isFinite(qty)&&qty>0)total+=qty;
  });
  return total;
}
function fetchFreshCartUl(){
  return fetch(headerSectionUrl(),{
    credentials:'same-origin',
    cache:'no-store',
    headers:{'Accept':'text/html'}
  }).then(function(response){
    if(!response.ok)throw new Error('Header refresh failed');
    return response.text();
  }).then(function(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var freshCart=doc.getElementById('cart');
    var freshUl=freshCart&&freshCart.querySelector('ul[data-money-format]');
    if(!freshUl)throw new Error('Fresh cart markup unavailable');
    return freshUl;
  });
}
function wait(ms){
  return new Promise(function(resolve){setTimeout(resolve,ms);});
}
function syncDrawer(cart,attempt){
  attempt=attempt||0;
  return fetchFreshCartUl().then(function(freshUl){
    var expected=parseInt(cart&&cart.item_count,10);
    if(!isFinite(expected)||expected<0)expected=0;
    var found=readMarkupCount(freshUl);

    if(found!==expected&&attempt<1){
      return wait(140).then(function(){return syncDrawer(cart,attempt+1);});
    }

    var currentCart=document.getElementById('cart');
    var currentUl=currentCart&&currentCart.querySelector('ul[data-money-format]');
    if(!currentUl)throw new Error('Current cart markup unavailable');

    /* Keep the live #cart/mmenu shell intact; refresh only its closed contents. */
    currentUl.innerHTML=freshUl.innerHTML;
    return true;
  });
}
function announceCartUpdated(cart){
  try{
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
  }catch(e){}
}
function addItem(button,form){
  if(!button||!form||button.getAttribute('data-bgc-quick-add-busy')==='1')return;

  var idInput=form.querySelector('[name="id"]');
  var variantId=idInput&&String(idInput.value||'').trim();
  if(!variantId)return;

  setBusy(button);

  fetch(route('cart/add.js'),{
    method:'POST',
    credentials:'same-origin',
    headers:{
      'Content-Type':'application/json',
      'Accept':'application/json'
    },
    body:JSON.stringify({
      items:[{
        id:variantId,
        quantity:quantityFrom(form)
      }]
    })
  }).then(function(response){
    if(!response.ok)throw new Error('Add to cart failed');
    return response.json();
  }).then(function(){
    return getCart();
  }).then(function(cart){
    updateHeaderCount(cart);
    return syncDrawer(cart,0).catch(function(){return false;}).then(function(){
      announceCartUpdated(cart);
      restoreButton(button,RESTORE_SUCCESS_MS,'ADDED ✓');
    });
  }).catch(function(){
    restoreButton(button,RESTORE_ERROR_MS,'TRY AGAIN');
  });
}

document.addEventListener('click',function(event){
  if(!desktopHome()||event.isTrusted===false)return;
  var button=closest(event.target,'.bgc-coffee-showcase .bgc-native-bypass-add');
  if(!button)return;
  var form=closest(button,'form');
  if(!form)return;

  /* Retina never receives this click, so its cart-presentation trigger cannot run. */
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  addItem(button,form);
},true);

document.addEventListener('shopify:section:load',function(){
  detachNativeButtons();
},false);

window.addEventListener('pageshow',function(){
  detachNativeButtons();
});

detachNativeButtons();
})();